import { useFeatureFlag } from "@evidenceb/athena-common/modules/FeatureFlags";
import { VisuallyHidden } from "@evidenceb/athena-common/ui/VisuallyHidden";
import cn from "classnames";
import { type MessageDescriptor, useIntl } from "react-intl";
import TriStateCheckbox, {
  type Props as TriStateCheckboxProps,
} from "../../../design-system-components/TriStateCheckbox/TriStateCheckbox";
import type { HierarchyPath, TreeNode } from "../types";
import { getNodeCheckboxId } from "../utils";

type Props = {
  hierarchyPath: HierarchyPath;
  label: string;
  checked: boolean | "mixed";
  childLeaves: (TreeNode & { hierarchyPath: HierarchyPath })[];
  onCheckNode: (hierarchyPath: HierarchyPath) => void;
  selectBranchLabel: (state: boolean | "mixed") => MessageDescriptor;
  variant?: TriStateCheckboxProps["variant"];
};

const BranchCheckbox = ({
  hierarchyPath,
  label,
  checked,
  childLeaves,
  onCheckNode,
  selectBranchLabel,
  variant,
}: Props) => {
  const intl = useIntl();

  const addBranchInPlaylistFlag = useFeatureFlag("addBranchInPlaylist");
  return (
    <TriStateCheckbox
      className={cn("tree-checkbox-list__title-checkbox", {
        clickable: addBranchInPlaylistFlag,
      })}
      checked={checked}
      aria-controls={
        addBranchInPlaylistFlag
          ? childLeaves
              .map((item) => getNodeCheckboxId(item.hierarchyPath))
              .join(" ")
          : undefined
      }
      onChange={() => {
        if (addBranchInPlaylistFlag) {
          onCheckNode(hierarchyPath);
        }
      }}
      variant={variant}
    >
      <VisuallyHidden>
        {intl.formatMessage(selectBranchLabel(checked), {
          branch: label,
        })}
      </VisuallyHidden>
    </TriStateCheckbox>
  );
};
export default BranchCheckbox;
